/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2026-01-09 16:41:35
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-01-09 17:18:29
 */
import { STORAGE_KEYS, DEFAULT_FOLDER_LEVELS } from '../constants'

interface FolderLevel {
  level: number
  field: string | undefined
}

interface PhotoTitleItem {
  titleId: string
  titleName: string
}

interface FolderTitleItem {
  titleId: string
  titleName: string
}

// 本地存储工具函数
export const saveSelection = (
  folderLevels: FolderLevel[],
  folderTitles: string,
  namingRule: string[]
): void => {
  try {
    localStorage.setItem(
      STORAGE_KEYS.MULTI_FOLDER_LAST_SELECTION,
      JSON.stringify(folderLevels)
    )
    // 为兼容性保留旧的单级键
    localStorage.setItem(
      STORAGE_KEYS.FOLDER_RULE,
      folderLevels[0] ? folderLevels[0].field || '' : ''
    )
    localStorage.setItem(STORAGE_KEYS.FOLDER_TITLES, folderTitles)
    localStorage.setItem(STORAGE_KEYS.NAMING_RULE, JSON.stringify(namingRule))
  } catch (error) {
    console.warn('error:', error)
  }
}

export const loadSelection = (): FolderLevel[] => {
  try {
    // 加载多级配置
    const saved = JSON.parse(
      localStorage.getItem(STORAGE_KEYS.MULTI_FOLDER_LAST_SELECTION) || 'null'
    )
    if (saved && Array.isArray(saved)) {
      return saved
    }

    // 回退到旧的单级配置
    const folderRule = localStorage.getItem(STORAGE_KEYS.FOLDER_RULE) || ''
    return [
      { level: 1, field: folderRule },
      { level: 2, field: undefined },
      { level: 3, field: undefined }
    ]
  } catch (error) {
    console.warn('error:', error)
    return DEFAULT_FOLDER_LEVELS
  }
}

export const loadNamingRule = (
  photoTitleList: PhotoTitleItem[]
): string[] | null => {
  try {
    const namingRule = JSON.parse(
      localStorage.getItem(STORAGE_KEYS.NAMING_RULE) || 'null'
    )
    if (namingRule && Array.isArray(namingRule)) {
      // 过滤掉不存在的 title 项
      return namingRule.filter((item) => {
        if (!item.includes('title')) {
          return true
        } else {
          const id = item.split('title')[1]
          return photoTitleList.some((photoItem) => photoItem.titleId === id)
        }
      })
    }
  } catch (error) {
    console.warn('error:', error)
  }
  return null
}

export const loadFolderTitles = (
  folderTitleList: FolderTitleItem[]
): string => {
  try {
    const folderTitles = localStorage.getItem(STORAGE_KEYS.FOLDER_TITLES)
    if (
      folderTitleList.length !== 0 &&
      folderTitles &&
      folderTitles !== 'watermark'
    ) {
      const index = folderTitleList.findIndex(
        (item) => item.titleId === folderTitles
      )
      return index >= 0 ? folderTitles : 'watermark'
    }
  } catch (error) {
    console.warn('error:', error)
  }
  return 'watermark'
}
